import React, { FC } from 'react';
import AgileLayout from '@components/agile/layout/AgileLayout';
import '@components/shared/Agile/AgileBase.css';
import { Outlet } from 'react-router-dom';
import { useAppContext } from '@components/agile/context/AppContext';

const AgileHome: FC = () => {
  const { programType } = useAppContext();
  return (
    <AgileLayout programType={programType}>
      <Outlet />
    </AgileLayout>
  );
};
export default AgileHome;
